import { Button, Menu, MenuItem } from "@mui/material";
import React from "react";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";

const AutoPatrolScheduleDropDown = () => {
  const {
    autoPatrolSchedules,
    selectedAutoPatrolScheduleIndex,
    setSelectedAutoPatrolScheduleIndex,
  } = useSiteAboutStore();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (autoPatrolSchedules !== null && autoPatrolSchedules.length > 0) {
    return (
      <div className="text-actuate-blue font-mulish text-[16px]">
        <Button
          id="schedule-selector"
          aria-controls={open ? "schedule-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          {autoPatrolSchedules[selectedAutoPatrolScheduleIndex]?.title}
        </Button>
        <Menu
          id="schedule-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "schedule-selector",
          }}
        >
          {autoPatrolSchedules.map((schedule, index) => (
            <MenuItem
              key={schedule.title}
              onClick={() => {
                setSelectedAutoPatrolScheduleIndex(index);
                handleClose();
              }}
            >
              {schedule.title}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
  }

  return null;
};

export default AutoPatrolScheduleDropDown;
